export default __webpack_public_path__ + "static/media/icon-close-filled-black.7e6ea832.svg";